import {Injectable} from '@angular/core';
import {MedicalRecordVisitReasonModel} from '../../api/model/medicalRecordVisitReason.model';
import {MedicalRecordVisitReasonCreateUpdatePayload} from './payload/medicalRecordVisitReasonCreateUpdate.payload';
import {AbstractSaveOneService} from '../../../../../core/service/v2/service/save/abstractSaveOne.service';
import {MedicalRecordVisitReasonRepository} from './ngrx/medicalRecordVisitReason.repository';
import {MedicalRecordVisitReasonDataServiceAdapter} from './ngrx/medicalRecordVisitReasonDataService.adapter';

@Injectable()
export class MedicalRecordVisitReasonSaveOneService
    extends AbstractSaveOneService<MedicalRecordVisitReasonModel, MedicalRecordVisitReasonCreateUpdatePayload> {

    constructor(public repository: MedicalRecordVisitReasonRepository,
                public dataServiceAdapter: MedicalRecordVisitReasonDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }

}